import { BOToothQuoteDetail } from "./BOToothQuoteDetail.model";


export class BOToothQuote{
  id:number;
  patientId:number; //Person.Id
  patientDocumentId?:number;
  patientDocumentIdString:string;
  date?:Date;
  odontogramaId?:number;
  name?:string;
  namePatient?:string;
  clinicHistoryId:number;
  toothQuoteDetails: BOToothQuoteDetail[]=[];
  total?:number;
}
